/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { PortableText } from '@portabletext/react';

interface HeaderDescriptionProps {
	description?: any;
	subtitle?: string;
}

export const HeaderDescription: React.FC<HeaderDescriptionProps> = ({
	description,
	subtitle,
}) => {
	// If we have rich text content from Sanity
	if (description) {
		return (
			<div className='mt-6 text-3xl leading-10 max-md:max-w-full'>
				<PortableText
					value={description}
					components={{
						block: {
							normal: ({ children }) => (
								<p className='font-normal'>{children}</p>
							),
						},
						marks: {
							strong: ({ children }) => (
								<span className='font-semibold'>{children}</span>
							),
						},
					}}
				/>
			</div>
		);
	}

	// Otherwise use subtitle or fallback to hardcoded text
	return (
		<p className='mt-6 text-3xl leading-10 max-md:max-w-full'>
			<span className='font-normal'>
				{subtitle || "Let's talk about how."}
			</span>{' '}
		</p>
	);
};
